import type { OpenString } from "../../lib/rhythm/rhythmPathPlan";

/** Colores de condicionamiento visual por cuerda (círculo numerado). */
export const STRING_BADGE_COLOR: Record<OpenString, string> = {
  1: "#34d399",
  2: "#60a5fa",
  3: "#c084fc",
  4: "#fbbf24",
  5: "#fb7185",
  6: "#94a3b8",
};

export interface StringNumberBadgeProps {
  openString: OpenString;
  active?: boolean;
  size?: "sm" | "md" | "lg";
  className?: string;
}

/**
 * Círculo con número de cuerda — señal visual primaria (sin texto "1ª cuerda").
 */
export function StringNumberBadge({
  openString,
  active = false,
  size = "md",
  className = "",
}: StringNumberBadgeProps) {
  const color = STRING_BADGE_COLOR[openString];
  const dim =
    size === "lg"
      ? "h-11 w-11 text-lg"
      : size === "sm"
        ? "h-6 w-6 text-[11px]"
        : "h-8 w-8 text-sm";

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center rounded-full font-bold tabular-nums transition-all duration-200 ${dim} ${className}`}
      style={{
        background: active ? color : `${color}33`,
        color: active ? "#0c0a09" : color,
        boxShadow: active
          ? `0 0 18px ${color}66, inset 0 0 0 2px ${color}`
          : `inset 0 0 0 1px ${color}66`,
      }}
      aria-label={`Cuerda ${openString}`}
      title={`Cuerda ${openString}`}
    >
      {openString}
    </span>
  );
}
